


















import { Component, Prop, Vue } from "vue-property-decorator";

import KpiCards from "./KpiCards.vue";
import TrendChart from "./TrendChart.vue";
import ScenarioWindowFootnote from "./ScenarioWindowFootnote.vue";
import { RcaFilters } from "./filterQueryParams";

/**
 * Overview tab: headline KPI cards + the daily impact trend chart, plus the scenario-window
 * footnote explaining the " *" markers.
 */
@Component({ components: { KpiCards, TrendChart, ScenarioWindowFootnote } })
export default class OverviewTab extends Vue {
    @Prop({ required: true }) startDate!: string;
    @Prop({ required: true }) endDate!: string;
    /** Metric catalog payload — passed through to the KPI cards and trend chart. */
    @Prop({ default: null }) catalog!: any;
    /** Global sidebar filters. */
    @Prop({ default: () => ({}) }) filters!: RcaFilters;
}
